import en from "date-fns/locale/en-US";
import ja from "date-fns/locale/ja";
import { useI18n } from "hooks/i18n/i18n";
import { useEffect } from "react";
import { registerLocale, setDefaultLocale } from "react-datepicker";

type RegisterLocaleArguments = Parameters<typeof registerLocale>;

const JA: RegisterLocaleArguments = ["ja", ja];
const getRegisterLocaleArguments = (
  locale: string
): RegisterLocaleArguments => {
  switch (locale) {
    case "en": {
      return ["en", en];
    }
    case "ja": {
      return JA;
    }
    default: {
      return JA;
    }
  }
};

export const useRegisterLocale = () => {
  const { i18n } = useI18n();

  registerLocale(...getRegisterLocaleArguments(i18n.language));

  useEffect(() => {
    setDefaultLocale(i18n.language);
  }, [i18n.language]);

  return { locale: i18n.language };
};
